export default {
  toast_messages: {
    google_review_uploaded: 'Twoja recenzja została zweryfikowana. Zyskujesz {{points}} pkt 😉',
  },
};
